import { RetailerFooter } from "@faire/deprecated-retailer-visitor-shared/components/Footer/RetailerFooter";
import {
  BlockInheritRow,
  ErrorRow,
} from "@faire/deprecated-retailer-visitor-shared/components/SearchProducts/SearchProductsStyles";
import { IEventSchema } from "@faire/web-api--source/indigofair/data/IEventSchema";
import { useProductAreaOnCall } from "@faire/web/common/hooks/useProductAreaOnCall";
import { LoadTimingRef } from "@faire/web/common/performance/userPerceivedLoadTiming/types";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React, { useCallback } from "react";
import { ErrorBoundary } from "react-error-boundary";

const SearchProductsError = ({
  refCallback,
}: {
  refCallback: LoadTimingRef;
}) => {
  const { onCallTag } = useProductAreaOnCall();

  const ref = useCallback(
    (element: HTMLDivElement | null) => {
      refCallback?.(element, {
        status: "error",
        error: "failed_to_render_critical_component",
        errorPriority: IEventSchema.Priority.CRITICAL,
        onCallTag,
      });
    },
    [refCallback]
  );

  return (
    <div ref={ref} style={{ width: "100%" }}>
      <ErrorRow justify="center">
        <Typography>
          <StrictLocalMsg
            id="bY8DY1"
            defaultMessage="An error has occurred, please try again."
            description={{
              text: "error message on search/discover and explore page when network failed",
            }}
          />
        </Typography>
      </ErrorRow>

      <BlockInheritRow>
        <RetailerFooter />
      </BlockInheritRow>
    </div>
  );
};

export const LoggedOutSearchUPLFErrorBoundary: React.FC<{
  refCallback: LoadTimingRef;
  children: React.ReactNode;
}> = ({ refCallback, children }) => {
  return (
    <ErrorBoundary fallback={<SearchProductsError refCallback={refCallback} />}>
      {children}
    </ErrorBoundary>
  );
};
